module.exports = {"pt-BR":{"components":{"not-found":{"heading":"404","content":"Página não encontrada","backToHome":"Voltar ao início"}}}}